import * as yup from 'yup';

const ChangePasswordSchema = yup.object().shape({
    oldPassword: yup.string()
        .required('Required'),
    password: yup.string()
        .required('Required')
        .notOneOf([yup.ref('oldPassword'), null], "Can't use the same password"),
    confirmPassword: yup.string()
        .required('Required')
        .oneOf([yup.ref('password'), null], "Passwords don't match")
});

export default ChangePasswordSchema;